import React from "react";
import WhatsApp from "./../../assets/socalImages/whatsapp.svg";
import Facebook from "./../../assets/socalImages/facebook.svg";
import Email from "./../../assets/socalImages/email.svg";
import X from "./../../assets/socalImages/twitter.svg";

const ShareSocial = ({
    url,
    shareOptions = { whatsapp: true, facebook: true, x: true, email: true },
    className = "",
    style = {},
}) => {
    if (!url) return null;

    const links = {
        whatsapp: {
            href: `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`,
            label: "WhatsApp",
            icon: WhatsApp,
        },
        facebook: {
            href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
            label: "Facebook",
            icon: Facebook,
        },
        x: {
            href: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
            label: "X",
            icon: X,
        },
        email: {
            href: `mailto:?subject=Check this out&body=${encodeURIComponent(url)}`,
            label: "Email",
            icon: Email,
        },
    };

    const items = Object.entries(links).filter(([key]) => shareOptions[key]);

    return (
        <div className="my-4">
            <h6>Share</h6>
            <div
                className={`d-flex gap-4 social-icons ${className}`}
                style={style}
            >
                {items.map(([key, { href, label, icon }]) => (
                    <a
                        key={key}
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        className="text-center text-decoration-none"
                    >
                        <div
                            className="d-flex align-items-center justify-content-center mx-auto mb-1"
                            style={{
                                width: "55px"
                            }}
                        >
                            <img
                                src={icon}
                                alt={label}
                                style={{
                                    width: 35,
                                    height: 35,
                                    objectFit: "contain",
                                }}
                            />
                        </div>
                        <div
                            className="small"
                            style={{
                                fontSize: "12px",
                                color: "#212529",
                                lineHeight: "1.2",
                                fontWeight: 500,
                            }}
                        >
                            {label}
                        </div>
                    </a>
                ))}
            </div>
            <style>{`
                .share-modal .social-icons {
                    justify-content: space-evenly;
                }
            `}</style>
        </div>
    );
};

export default ShareSocial;
